import { SvgIcon } from '@mui/material';

const CompostIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <g clipPath="url(#a)">
          <path
            d="M16.163.506a1.71 1.71 0 0 0-1.47-.488A19.6 19.6 0 0 0 4.17 5.246a5.17 5.17 0 0 0-1.498 3.89 5.1 5.1 0 0 0 1.046 2.868L.695 15.029l.943.943 3.023-3.023a4.96 4.96 0 0 0 3.066 1.047 5.47 5.47 0 0 0 3.94-1.702A19.8 19.8 0 0 0 16.65 1.961a1.7 1.7 0 0 0-.487-1.455M4.005 9.072a3.83 3.83 0 0 1 1.11-2.884c.288-.29.585-.557.885-.814v4.35l-1.327 1.327a3.8 3.8 0 0 1-.668-1.979m6.698 2.3a3.94 3.94 0 0 1-5.085.62l3.325-3.325h3.831a16 16 0 0 1-2.071 2.706m4.626-9.6a19.2 19.2 0 0 1-1.811 5.562h-3.242l2.362-2.362-.943-.943-4.362 4.36V4.345a18.95 18.95 0 0 1 7.552-3.007l.058-.004a.39.39 0 0 1 .37.263.4.4 0 0 1 .016.174z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="currentColor" d="M.666 0h16v16h-16z" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default CompostIcon;
